export default function(ajProgress) {
  return ajProgress
    ? ajProgress.split('-').map(item => Boolean(Number(item)))
    : [false, false, false]
}
